var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgBlogTiktok = function SvgSvgBlogTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 7.38a7.386 7.386 0 0 1-4.317-1.382v6.286a5.716 5.716 0 1 1-4.93-5.664v3.16a2.623 2.623 0 1 0 1.836 2.504V0h3.094c-.002.262.02.523.067.78a4.296 4.296 0 0 0 1.895 2.82 4.268 4.268 0 0 0 2.355.707v3.072Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h15.75v18H0z"
  })))));
};
export default SvgSvgBlogTiktok;